import { RoleResponse } from '../../../types/role';
import { ApiAbstract } from '../abstract';

export class ApiRole extends ApiAbstract<RoleResponse, RoleResponse> {}
